var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"connect",attrs:{"id":"websocket"}},[_c('el-input',{model:{value:(_vm.message),callback:function ($$v) {_vm.message=$$v},expression:"message"}}),_c('el-button',{on:{"click":_vm.sendDataToServer}},[_vm._v("connect")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }